import React, { useMemo } from 'react';
import TimeGrid from './TimeGrid';
import { startOfDay } from './calendarItems';

export default function DayView({ items, cursor, onSelect }) {
  const days = useMemo(() => [startOfDay(cursor)], [cursor]);
  return <TimeGrid days={days} items={items} onSelect={onSelect} testId="calendar-day-view" />;
}
